// @TODO: check if problem with deprecated import warning is fixed.
// PR https://github.com/mksarge/redux-first-routing/pull/3/commits.
import { createBrowserHistory } from 'redux-first-routing';
// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
export default process.env.BROWSER && createBrowserHistory();
